import { render, staticRenderFns } from "./deviceAttributes.vue?vue&type=template&id=8f8e8de4"
import script from "./deviceAttributes.vue?vue&type=script&lang=js"
export * from "./deviceAttributes.vue?vue&type=script&lang=js"
import style0 from "./deviceAttributes.vue?vue&type=style&index=0&id=8f8e8de4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports